module.exports = __webpack_public_path__ + "media/images/level_introduction2_sp-4416ac0558906ac949c7d780f0824a47.png";